import { render, staticRenderFns } from "./FuneralHomeShop.vue?vue&type=template&id=bff22080"
import script from "./FuneralHomeShop.vue?vue&type=script&lang=js"
export * from "./FuneralHomeShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports